module.exports = __webpack_public_path__ + "img/3.48e8ed9c.svg";